import React, { useEffect } from "react";
import Modal from "components/Modal";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleInviteTemplateAction } from "redux/actions/fetchSingleInviteTemplateAction ";
import { useParams } from "react-router-dom";
import TabInfo from "containers/InvitationTemplateDetails/tabs/TabInfo";
import TabEdit from "containers/InvitationTemplateDetails/tabs/TabEdit";

import "./style.scss";

export default function InvitationTemplateDetail() {

    const [t] = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { inviteTemplate } = useSelector(state => state.invite);
    const params = useParams();
    const { bookId } = params;
   
    useEffect(() => {
        dispatch(fetchSingleInviteTemplateAction(bookId));
    }, [dispatch, bookId]);


    const onClose = () => history.push("/templates");

    const tabs = [
        {
            tabName: "info",
              component: <TabInfo template={inviteTemplate}  key="info" />
           
        },
        {
            tabName: "edit",
            component: <TabEdit template={inviteTemplate}  onClose={onClose} />
           
        }
    ];

    return inviteTemplate &&  (
        <div className="organisation-detail">
            <Modal
                title={t("admin.menu.template.name")}
                basePath={`/templates/template/67dbf36bdc5c83039742bd0d`}
                tabs={tabs}
                onClose={onClose}
            />
        </div>
    );
}